/* eslint-disable jsx-a11y/anchor-is-valid */
import { DateHelper } from '../../helpers/dateHelper';
import { currencyFormatterHelper } from '../../helpers/currencyFormatterHelper';
import { Box } from '@mui/material';
import { buildRegionizeRoute } from '../../helpers/regionRouteHelper';
import { AppRoutes } from '../../constants/appRoutes';

export function InitializeColumnsInvestorSignUp() {
	return [
		{
			header: 'ID',
			accessorKey: 'id',
		},
		{
			header: 'Email',
			accessorKey: 'email',
		},
		{
			header: 'Start Date',
			accessorKey: 'signUpDate',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue());
			},
		},
		{
			header: 'Status Set Date',
			accessorKey: 'statusSetDate',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue());
			},
		},
		{
			header: 'First Name',
			accessorKey: 'firstName',
		},
		{
			header: 'Last Name',
			accessorKey: 'lastName',
		},
	];
}

export function InitializeColumnsInvestorDeposit() {
	return [
		{
			header: 'ID',
			accessorKey: 'id',
		},
		{
			header: 'Email',
			accessorKey: 'investorEmail',
		},
		{
			header: 'SignUp Date',
			accessorKey: 'investorSignUpDate',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue());
			},
		},
		{
			header: 'Amount',
			accessorKey: 'amount',
		},
		{
			header: 'Residency',
			accessorKey: 'residency',
		},
		{
			header: 'Transaction Date',
			accessorKey: 'transactionDate',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue());
			},
		},
		{
			header: 'User Id',
			accessorKey: 'userId',
		},
		{
			header: 'User Identity',
			accessorKey: 'userIdentity',
		},
	];
}


export function InitializeColumnsInvestorWithdrawal() {
	return [
		{
			header: 'ID',
			accessorKey: 'id',
		},
		{
			header: 'Email',
			accessorKey: 'investorEmail',
		},
		{
			header: 'SignUp Date',
			accessorKey: 'investorSignUpDate',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue());
			},
		},
		{
			header: 'Amount',
			accessorKey: 'amount',
		},
		{
			header: 'Residency',
			accessorKey: 'residency',
		},
		{
			header: 'Transaction Date',
			accessorKey: 'transactionDate',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue());
			},
		},
		{
			header: 'User Id',
			accessorKey: 'userId',
		},
		{
			header: 'User Identity',
			accessorKey: 'userIdentity',
		},
	];
}

export function InitializeColumnsBorrowerSignUp() {
	return [
		{
			header: 'ID',
			accessorKey: 'id',
		},
		{
			header: 'Email',
			accessorKey: 'email',
		},
		{
			header: 'Start Date',
			accessorKey: 'signUpDate',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue());
			},
		},
		{
			header: 'Status Set Date',
			accessorKey: 'statusSetDate',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue());
			},
		},
		{
			header: 'Business Name',
			accessorKey: 'businessName',
		},
		{
			header: 'First Name',
			accessorKey: 'firstName',
		},
		{
			header: 'Last Name',
			accessorKey: 'lastName',
		},
	];
}

export function InitializeColumnsBorrowerShareholders() {
	return [
		{
			header: 'Borrower name',
			accessorKey: 'userFullName',
		},
		{
			header: 'Name',
			accessorKey: 'fullName',
		},
		{
			header: 'Passport No',
			accessorKey: 'passportNo',
		},
		{
			header: 'Position',
			accessorKey: 'position',
		},
		{
			header: 'Date of Birth Date',
			accessorKey: 'dob',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue());
			},
		},
		{
			header: 'Passport Expiry',
			accessorKey: 'passportExpiry',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue());
			},
		},
		{
			header: 'Nationality',
			accessorKey: 'nationality.name',
		},
		{
			header: 'Address',
			accessorKey: 'address',
		},
		{
			header: 'Shareholding',
			accessorKey: 'shareholding',
		},
		{
			header: 'ShareHolding Percent',
			accessorKey: 'shareHoldingPercent',
		},
		{
			header: 'Signatory',
			accessorKey: 'signatory',
		},
	];
}

export function InitializeColumnsDFSA(totalInvestors = 0, totalBorrowers = 0) {
	return [
		{
			header: 'Region Name',
			accessorKey: 'regionName',
		},
		{
			header: 'Investors',
			accessorKey: 'investorsCount',
			Footer: (row) => (
				<Box>{totalInvestors}</Box>
			),
		},
		{
			header: 'Borrowers',
			accessorKey: 'borrowersCount',
			Footer: (row) => (
				<Box>{totalBorrowers}</Box>
			),
		},
	];
}

export function InitializeColumnsDFSAOpportunities() {
	return [
		{
			header: 'First Name',
			accessorKey: 'firstName',
			size: 90,
		},
		{
			header: 'Last Name',
			accessorKey: 'lastName',
			size: 90,
		},
		{
			header: 'Email',
			accessorKey: 'email',
			size: 90,
		},
		{
			header: 'Investor Type',
			accessorKey: 'investorType.name',
			size: 90,
		},
		{
			header: 'Country',
			accessorKey: 'country.name',
			size: 90,
		},
		{
			header: 'Contact Number',
			accessorKey: 'contactPhoneNumber',
			size: 90,
		},
		{
			header: 'Loans',
			accessorKey: 'loans',
			size: 90,
		},
		{
			header: 'Amount Invested',
			accessorKey: 'totalAmount',
			size: 90,
		},
	];
}

export function InitializeColumnsInvestorsShareholders() {
	return [
		{
			header: 'Investor name',
			accessorKey: 'userFullName',
		},
		{
			header: 'Name',
			accessorKey: 'fullName',
		},
		{
			header: 'Passport No',
			accessorKey: 'passportNo',
		},
		{
			header: 'Position',
			accessorKey: 'position',
		},
		{
			header: 'Date of Birth Date',
			accessorKey: 'dob',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue());
			},
		},
		{
			header: 'Passport Expiry',
			accessorKey: 'passportExpiry',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue());
			},
		},
		{
			header: 'Nationality',
			accessorKey: 'nationality.name',
		},
		{
			header: 'Address',
			accessorKey: 'address',
		},
		{
			header: 'Shareholding',
			accessorKey: 'shareholding',
		},
		{
			header: 'ShareHolding Percent',
			accessorKey: 'shareHoldingPercent',
		},
		{
			header: 'Signatory',
			accessorKey: 'signatory',
		},
	];
}

export function InitializeColumnsApprovedInvestors() {
	return [
		{
			header: 'ID',
			accessorKey: 'id',
		},
		{
			header: 'Application Id',
			accessorKey: 'applicationId',
		},
		{
			header: 'Business/Investors name',
			accessorKey: 'name',
		},
		{
			header: 'Email',
			accessorKey: 'email',
		},
		{
			header: 'Invested Amount',
			accessorKey: 'InvestedAmount',
		},
		{
			header: 'Repayments',
			accessorKey: 'NetEarnings',
			size: 80,
		},
		{
			header: 'Closing balance',
			accessorKey: 'availableCash',
			size: 80,
		},
		{
			header: 'Compliance risk rating',
			accessorKey: 'amlRiskRating.name',
		},
		{
			header: 'Number of Opportunities',
			accessorKey: 'numberOfOpportunities',
		},
		{
			header: 'Approved Date',
			accessorKey: 'approvedDate',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue());
			},
			size: 80,
		},
		{
			header: 'Onboarding Date',
			accessorKey: 'signUpDate',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue());
			},
			size: 80,
		},
	];
}

export function InitializeColumnsAECB() {
	return [
		{
			header: 'ID',
			accessorKey: 'id',
		},
		{
			header: 'Provider Code',
			accessorKey: 'providerCode',
		},
		{
			header: 'Batch Id',
			accessorKey: 'batchId',
		},
		{
			header: 'Create Date',
			accessorKey: 'createDate',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue());
			},
		},
	];
}

export function InitializeColumnsCRSData() {
	return [
		{
			header: 'Account Number',
			accessorKey: 'applicationId',
			enableClickToCopy: true,
		},
		{
			header: 'Opening Date',
			accessorKey: 'openingDate',
			size: 80,
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue());
			},
		},
		{
			header: 'Closure Date',
			accessorKey: 'closureDate',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue());
			},
			size: 80,
		},
		{
			header: 'Is Closed',
			accessorKey: 'isClosed',
			Cell: ({ cell }) => {
				return cell?.getValue() ? 'Yes' : 'No';
			},
			size: 60,
		},
		{
			header: 'Is Dormant',
			accessorKey: 'isDormant',
			Cell: ({ cell }) => {
				return cell?.getValue() ? 'Yes' : 'No';
			},
			size: 60,
		},
		{
			header: 'First Name',
			accessorKey: 'firstName',
		},
		{
			header: 'Last Name',
			accessorKey: 'lastName',
		},
		{
			header: 'Date of Birth',
			accessorKey: 'birthDate',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue());
			},
			size: 80,
		},
		{
			header: 'Birth City',
			accessorKey: 'birthCity',
			size: 80,
		},
		{
			header: 'Country',
			accessorKey: 'country',
			size: 80,
		},
		{
			header: 'City',
			accessorKey: 'city',
			size: 80,
		},
		{
			header: 'Street',
			accessorKey: 'street',
			size: 80,
		},
		{
			header: 'Tax Residency 1',
			accessorKey: 'taxResidency1',
			size: 80,
		},
		{
			header: 'TIN Issuer 1',
			accessorKey: 'tinIssuer1',
			size: 80,
		},
		{
			header: 'TIN 1',
			accessorKey: 'tin1',
			size: 80,
		},
		{
			header: 'Tax Residency 2',
			accessorKey: 'taxResidency2',
			size: 80,
		},
		{
			header: 'TIN Issuer 2',
			accessorKey: 'tinIssuer2',
			size: 80,
		},
		{
			header: 'TIN 2',
			accessorKey: 'tin2',
			size: 80,
		},
		{
			header: 'Currency',
			accessorKey: 'currency',
			size: 80,
		},
		{
			header: 'Virtual IBAN',
			accessorKey: 'virtualIban',
			size: 80,
		},
		{
			header: 'Are you taxed elsewhere?',
			accessorKey: 'isTaxedElsewhere',
			size: 120,
			Cell: ({ cell }) => {
				return <Box>{cell?.getValue() ? 'Yes' : 'No'}</Box>;
			},
		},
		{
			header: 'Balance ',
			accessorKey: 'balance',
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
			size: 80,
		},
		{
			header: 'Interest',
			accessorKey: 'interest',
			size: 80,
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
		},
		{
			header: 'Gross Proceeds / Redemptions',
			accessorKey: 'grossProceedsOrRedemptions',
			size: 80,
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
		},
	];
}

export function InitializeColumnsPromoCodeReport() {
	return [
		{
			header: 'Code Name',
			accessorKey: 'code',
			enableClickToCopy: true,
		},
		{
			header: 'Loan Id',
			accessorKey: 'loanId',
			enableClickToCopy: true,
		},
		{
			header: 'Business Name',
			accessorKey: 'loanBusinessName',
		},
		{
			header: 'Investor Name',
			accessorKey: 'userFullName',
		},
		{
			header: 'Investment Amount',
			accessorKey: 'investmentAmount',
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
		},
		{
			header: 'Cashback Amount',
			accessorKey: 'cashbackAmount',
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
		},
		{
			header: 'Status',
			accessorKey: 'status',
			Cell: ({ cell }) => {
				return getStatus(cell?.getValue());
			},
		},
		{
			header: 'Date Applied',
			accessorKey: 'usedAt',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue());
			},
		},
	];
}

const getStatus = (status) => {
	if (status === 0) {
		return 'Pending';
	}
	if (status === 1) {
		return 'Confirmed';
	}
	if (status === 2) {
		return 'Rejected';
	}
	if (status === 3) {
		return 'Cancelled';
	}
};

const surveyPointLink = ({ cell, row, columnName = '', onSurveyPointClick = () => { } }) => {
	let ratings = row?.original?.ratings || [];
	let count = ratings.find(resp => resp.rating === columnName)?.items?.length;
	return <a className={`${!count ? 'caption cursor-default !no-underline' : '!font-bold !text-[14px] underline-link'}`} onClick={(e) => { if (!count) return; onSurveyPointClick(row, columnName); }}>{count || "---"}</a>;
};

export function InitializeColumnsUserSurvey({ onSurveyPointClick = (row, currentPoint) => { } }) {
	return [
		{
			header: 'Quarter',
			accessorKey: 'quarter',
			size: 80,
		},
		{
			header: '1',
			accessorKey: 'one',
			Cell: ({ cell, row }) => {
				return surveyPointLink({
					cell: cell, row: row, columnName: 1, onSurveyPointClick: () => {
						onSurveyPointClick(row, 1);
					}
				});
			},
			size: 80,
		},
		{
			header: '2',
			accessorKey: 'two',
			Cell: ({ cell, row }) => {
				return surveyPointLink({
					cell: cell, row: row, columnName: 2, onSurveyPointClick: () => {
						onSurveyPointClick(row, 2);
					}
				});
			},
			size: 80,
		},
		{
			header: '3',
			accessorKey: 'three',
			Cell: ({ cell, row }) => {
				return surveyPointLink({
					cell: cell, row: row, columnName: 3, onSurveyPointClick: () => {
						onSurveyPointClick(row, 3);
					}
				});
			},
			size: 80,
		},
		{
			header: '4',
			accessorKey: 'four',
			Cell: ({ cell, row }) => {
				return surveyPointLink({
					cell: cell, row: row, columnName: 4, onSurveyPointClick: () => {
						onSurveyPointClick(row, 4);
					}
				});
			},
			size: 80,
		},
		{
			header: '5',
			accessorKey: 'five',
			Cell: ({ cell, row }) => {
				return surveyPointLink({
					cell: cell, row: row, columnName: 5, onSurveyPointClick: () => {
						onSurveyPointClick(row, 5);
					}
				});
			},
			size: 80,
		},
		{
			header: '6',
			accessorKey: 'six',
			Cell: ({ cell, row }) => {
				return surveyPointLink({
					cell: cell, row: row, columnName: 6, onSurveyPointClick: () => {
						onSurveyPointClick(row, 6);
					}
				});
			},
			size: 80,
		},
		{
			header: '7',
			accessorKey: 'seven',
			Cell: ({ cell, row }) => {
				return surveyPointLink({
					cell: cell, row: row, columnName: 7, onSurveyPointClick: () => {
						onSurveyPointClick(row, 7);
					}
				});
			},
			size: 80,
		},
		{
			header: '8',
			accessorKey: 'eight',
			Cell: ({ cell, row }) => {
				return surveyPointLink({
					cell: cell, row: row, columnName: 8, onSurveyPointClick: () => {
						onSurveyPointClick(row, 8);
					}
				});
			},
			size: 80,
		},
		{
			header: '9',
			accessorKey: 'nine',
			Cell: ({ cell, row }) => {
				return surveyPointLink({
					cell: cell, row: row, columnName: 9, onSurveyPointClick: () => {
						onSurveyPointClick(row, 9);
					}
				});
			},
			size: 80,
		},
		{
			header: '10',
			accessorKey: 'ten',
			Cell: ({ cell, row }) => {
				return surveyPointLink({
					cell: cell, row: row, columnName: 10, onSurveyPointClick: () => {
						onSurveyPointClick(row, 10);
					}
				});
			},
			size: 80,
		},
	];
}

export function InitializeSurveyUsersDetail() {
	return [
		{
			header: 'First Name',
			accessorKey: 'firstName',
		},
		{
			header: 'Last Name',
			accessorKey: 'lastName',
		},
		{
			header: 'Email',
			accessorKey: 'email',
			enableClickToCopy: true,
		},
		{
			header: 'Mobile Number',
			accessorKey: 'phoneNumber',
			enableClickToCopy: true,
		},
		{
			header: 'Suggestion',
			accessorKey: 'suggestion',
		},
	];
}

export function InitializeAcquisitionReport() {
	return [
		{
			header: 'Application ID',
			accessorKey: 'applicationId',
		},
		{
			header: 'Sign Up Date',
			accessorKey: 'signUpDate',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue(), 'dd/MM/yyyy');
			},
		},
		{
			header: 'How did you hear about us?',
			accessorKey: 'howDidYouHearAboutUs',
		},
		{
			header: 'Utm Source',
			accessorKey: 'Utm_Source',
			enableClickToCopy: true,
		},
		{
			header: 'Utm Medium',
			accessorKey: 'Utm_Medium',
		},
		{
			header: 'Utm Campaign',
			accessorKey: 'Utm_Campaign',
		},
		{
			header: 'Utm Term',
			accessorKey: 'Utm_Term',
		},
		{
			header: 'Utm Content',
			accessorKey: 'Utm_Content',
		},
	];
}

export function InitializeMarketingReport() {
	return [
		{
			header: 'Application ID',
			accessorKey: 'applicationId',
		},
		{
			header: 'First Name',
			accessorKey: 'firstName',
		},
		{
			header: 'Last Name',
			accessorKey: 'lastName',
		},
		{
			header: 'Email',
			accessorKey: 'email',
		},
		{
			header: 'Phone Number',
			accessorKey: 'phoneNumber',
		},
		{
			header: 'Gender ',
			accessorKey: 'gender',
		},
		{
			header: 'Date of Birth',
			accessorKey: 'birthDate',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue(), 'dd/MM/yyyy');
			},
		},
		{
			header: 'Nationality',
			accessorKey: 'nationality',
		},
		{
			header: 'Country of Residence',
			accessorKey: 'countryOfResidence',
		},
		{
			header: 'Address 1',
			accessorKey: 'address1',
		},
		{
			header: 'Address 2',
			accessorKey: 'address2',
		},
		{
			header: 'Soucre of Income',
			accessorKey: 'incomeSourceSpecified ',
		},
		{
			header: 'Annual Income',
			accessorKey: 'annualIncome',
		},
		{
			header: 'Net Worth',
			accessorKey: 'netWorth',
		},
		{
			header: 'Estimated Annual Investment',
			accessorKey: 'estimatedAnnualInvestment',
		},
		{
			header: 'Employment Status',
			accessorKey: 'employmentStatus',
		},
		{
			header: 'Job Title',
			accessorKey: 'jobTitle',
		},
		{
			header: 'Company Name ',
			accessorKey: 'companyName ',
		},
		{
			header: 'Sign-up Date',
			accessorKey: 'signUpDate',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue(), 'dd/MM/yyyy');
			},
		},
		{
			header: 'Approval Date',
			accessorKey: 'approvalDate',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue(), 'dd/MM/yyyy');
			},
		},
		{
			header: 'First Deposit Date',
			accessorKey: 'firstDepositDate',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue(), 'dd/MM/yyyy');
			},
		},
		{
			header: 'Last Deposit Date',
			accessorKey: 'lastDepositDate',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue(), 'dd/MM/yyyy');
			},
		},
		{
			header: 'First Investment Date',
			accessorKey: 'firstInvestmentDate',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue(), 'dd/MM/yyyy');
			},
		},
		{
			header: 'Last Investment Date',
			accessorKey: 'lastInvestmentDate',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue(), 'dd/MM/yyyy');
			},
		},
		{
			header: 'First Withdrawal Date ',
			accessorKey: 'firstWithdrawalDate',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue(), 'dd/MM/yyyy');
			},
		},
		{
			header: 'Last Withdrawal Date ',
			accessorKey: 'lastWithdrawalDate',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue(), 'dd/MM/yyyy');
			},
		},
		{
			header: 'Last Login Date ',
			accessorKey: 'lastLoginDate',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue(), 'dd/MM/yyyy');
			},
		},
		{
			header: 'Upgrade to Pro Date',
			accessorKey: 'upgradeToProDate',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue(), 'dd/MM/yyyy');
			},
		},
		{
			header: 'Archive Date',
			accessorKey: 'archiveDate',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue(), 'dd/MM/yyyy');
			},
		},
		{
			header: 'Investment Strategy',
			accessorKey: 'investmentStrategy',
		},
		{
			header: 'Investor Type',
			accessorKey: 'investorType',
		},
		{
			header: 'Registration Step',
			accessorKey: 'registrationStep',
		},
		{
			header: 'Status',
			accessorKey: 'status',
		},
		{
			header: 'Is KYC Pending',
			accessorKey: 'isKycPending',
			Cell: ({ cell }) => {
				return cell?.getValue() ? 'Yes' : 'No';
			},
		},
		{
			header: 'Is Depositing First Time',
			accessorKey: 'IsDepositingForFirstTime',
			Cell: ({ cell }) => {
				return cell?.getValue() ? 'Yes' : 'No';
			},
		},
		{
			header: 'Is Investing First Time',
			accessorKey: 'IsInvestingForFirstTime',
			Cell: ({ cell }) => {
				return cell?.getValue() ? 'Yes' : 'No';
			},
		},
		{
			header: 'Is Active Investor',
			accessorKey: 'IsActiveInvestor',
			Cell: ({ cell }) => {
				return cell?.getValue() ? 'Yes' : 'No';
			},
		},
		{
			header: 'Is Approved Investor',
			accessorKey: 'IsApprovedInvestor',
			Cell: ({ cell }) => {
				return cell?.getValue() ? 'Yes' : 'No';
			},
		},
		{
			header: 'How did you hear about us?',
			accessorKey: 'howDidYouHearAboutUs',
		},
		{
			header: 'Utm Source',
			accessorKey: 'utmSource',
		},
		{
			header: 'Utm Medium',
			accessorKey: 'utmMedium',
		},
		{
			header: 'Utm Campaign',
			accessorKey: 'utmCampaign',
		},
		{
			header: 'Utm Term',
			accessorKey: 'utmTerm',
		},
		{
			header: 'Utm Content',
			accessorKey: 'utmContent',
		},
		{
			header: 'Age when signed up ',
			accessorKey: 'ageWhenSignedUp',
		},
		{
			header: 'Age Today',
			accessorKey: 'ageToday',
		},
		{
			header: 'Is Uploaded Required Documents',
			accessorKey: 'uploadedRequiredDocuments',
			Cell: ({ cell }) => {
				return cell?.getValue() ? 'Yes' : 'No';
			},
		},
		{
			header: 'Reversed Amount',
			accessorKey: 'reservedAmount',
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
		},
		{
			header: 'Available Cash',
			accessorKey: 'availableCash',
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
		},
		{
			header: 'Duration of Investment (Months)',
			accessorKey: 'durationOfInvestmentMonths',
		},
		{
			header: 'Sign-up/Upload (Minutes)',
			accessorKey: 'signUpToUploadMinutes',
		},
		{
			header: 'Upload Docs/Approval (Days)',
			accessorKey: 'uploadToApprovalDays',
		},
		{
			header: 'Approval/Deposit (Days)',
			accessorKey: 'approvalToDepositDays',
		},
		{
			header: 'Deposit/Invest (Days)',
			accessorKey: 'depositToInvestDays',
		},
		{
			header: 'Sign-up/Invest (Days)',
			accessorKey: 'signUpToApprovalDays',
		},
		{
			header: 'Sign-up/Deposit (Days)',
			accessorKey: 'signUpToDepositDays',
		},
		{
			header: 'Sign-up/Approved (Days)',
			accessorKey: 'signUpToInvestDays',
		},
		{
			header: 'Signup/Upgrade to Pro (Days) ',
			accessorKey: 'signUpToProDays',
		},
		{
			header: 'Approved/Pro (days)',
			accessorKey: 'approvedToProDays',
		},
		{
			header: 'Withdrawals Transaction Count',
			accessorKey: 'withdrawalsTransactionCount',
		},
		{
			header: 'Investment Transactions (Including Auto Investing)',
			accessorKey: 'investmentTransactionCountIncludingAuto',
		},
		{
			header: 'Investment Transactions (Excluding Auto Investing)',
			accessorKey: 'investmentTransactionCountExcludingAuto',
		},
		{
			header: 'Deposit Transaction Count',
			accessorKey: 'depositTransactionCount',
		},
		{
			header: 'Number of opportunity invested in',
			accessorKey: 'numberOfOpportunitiesInvested',
		},
		{
			header: 'Total Portfolio',
			accessorKey: 'totalPortfolio',
		},
		{
			header: 'Total Investment',
			accessorKey: 'totalInvestment',
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
		},
		{
			header: 'Deposit Amount',
			accessorKey: 'totalDepositAmount',
		},
		{
			header: 'Withdrawals Amount',
			accessorKey: 'totalWithdrawalsAmount',
		},
		{
			header: 'Net Deposit',
			accessorKey: 'netDeposit',
		},
		{
			header: 'Investment Amount (Including Auto Investing)',
			accessorKey: 'investmentAmountIncludingAuto',
		},
		{
			header: 'Investment Amount (Excluding Auto Investing)',
			accessorKey: 'investmentAmountExcludingAuto',
		},
		{
			header: 'Deposit Remained  (2020)',
			accessorKey: 'yearlyDepositAmount.2020',
		},
		{
			header: 'Deposit Remained (2021)',
			accessorKey: 'yearlyDepositAmount.2021',
		},
		{
			header: 'Deposit Remained (2022)',
			accessorKey: 'yearlyDepositAmount.2022',
		},
		{
			header: 'Deposit Remained (2023)',
			accessorKey: 'yearlyDepositAmount.2023',
		},
		{
			header: 'Deposit Remained (2024)',
			accessorKey: 'yearlyDepositAmount.2024',
		},
		{
			header: 'Deposit Remained (2025)',
			accessorKey: 'yearlyDepositAmount.2025',
		},
		// {
		// 	header: 'NPS Score',
		// 	accessorKey: 'nPSScore',
		// },
		// {
		// 	header: 'User Comments',
		// 	accessorKey: 'suggestions',
		// },
		{
			header: 'Milestone Date - 50K  (Days)',
			accessorKey: 'mileStoneTo50KDepositInDays',
		},
		{
			header: 'Milestone Date - 100K  (Days)',
			accessorKey: 'mileStoneTo100KDepositInDays',
		},
		{
			header: 'Milestone Date - 250K  (Days)',
			accessorKey: 'mileStoneTo250KDepositInDays',
		},
		{
			header: 'Milestone Date - 500K  (Days)',
			accessorKey: 'mileStoneTo500KDepositInDays',
		},
		{
			header: 'Milestone Date - 750K  (Days)',
			accessorKey: 'mileStoneTo750KDepositInDays',
		},
		{
			header: 'Milestone Date - 1M  (Days)',
			accessorKey: 'mileStoneTo1MDepositInDays',
		},
		{
			header: 'Language',
			accessorKey: 'language',
		},
		{
			header: 'Communication Channel',
			accessorKey: 'communicationChannel',
		},
		{
			header: 'Channel',
			accessorKey: 'channel',
		},
		{
			header: 'Content',
			accessorKey: 'content',
		}
	];
}
export function InitializeColumnsLoanTapeReport() {
	return [
		{
			header: 'Borrower id',
			accessorKey: 'borrowerId',
			Cell: ({ cell }) => {
				return <a className='underline-link' href={buildRegionizeRoute(`${AppRoutes.Borrowers}/${cell?.getValue()}`)}>
					{cell?.getValue()}
				</a>;
			},
		},
		{
			header: 'Loan id',
			accessorKey: 'loanId',
			Cell: ({ cell }) => {
				return <a className='underline-link' href={buildRegionizeRoute(`${AppRoutes.Loans}/${cell?.getValue()}`)}>
					{cell?.getValue()}
				</a>;
			},
		},
		{
			header: 'Industry',
			accessorKey: 'borrowerIndustry',
			Cell: ({ cell }) => {
				return <Box className='w-[320px] overflow-hidden whitespace-break-spaces'>
					{cell?.getValue()}
				</Box>;
			},
		},
		{
			header: 'Collateral Name',
			accessorKey: 'collateralName',
			size: 80,
		},
		{
			header: 'Term start',
			accessorKey: 'termStart',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue());
			},
			size: 80,
		},
		{
			header: 'Term end',
			accessorKey: 'termEnd',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue());
			},
			size: 80,
		},
		{
			header: 'Payment Frequency',
			accessorKey: 'paymentFrequency',
			size: 80,
		},

		{
			header: 'Principal & Profit',
			accessorKey: 'principalAndProfit',
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
			size: 80,
		},
		{
			header: 'Principal',
			accessorKey: 'principal',
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
			size: 80,
		},
		{
			header: 'Profit',
			accessorKey: 'profit',
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
			size: 80,
		},
		{
			header: 'Principal Paid',
			accessorKey: 'principalPaid',
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
			size: 80,
		},
		{
			header: 'Profit Paid',
			accessorKey: 'profitPaid',
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
			size: 80,
		},
		{
			header: 'Origination Paid',
			accessorKey: 'feesPaid',
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
			size: 80,
		},
		{
			header: 'Total Paid',
			accessorKey: 'totalPaid',
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
			size: 80,
		},
		{
			header: 'Principal Outstanding',
			accessorKey: 'principalOutstanding',
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
			size: 140
		},
		{
			header: 'Profit Outstanding',
			accessorKey: 'profitOutstanding',
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
			size: 140
		},
		{
			header: 'Total Outstanding',
			accessorKey: 'totalOutstanding',
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
		},
		{
			header: 'Status',
			accessorKey: 'status',
			size: 80,
		},
		{
			header: 'Day Past Due',
			accessorKey: 'dayPastDue',
			size: 80,
		},
		{
			header: 'Defaulted Amount',
			accessorKey: 'defaultedAmount',
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
			size: 80,
		},
		{
			header: 'Defaulted Date',
			accessorKey: 'defaultedDate',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue());
			},
			size: 80,
		},
		// {
		// 	header: 'Borrower Industry',
		// 	accessorKey: 'borrowerIndustry',
		// 	size: 80,
		// },
	];
}

export function InitializeColumnsInvestorDailyBalances() {
	return [
		{
			header: 'Investor ID',
			accessorKey: 'investorUserId',
			enableClickToCopy: true,
		},
		{
			header: 'First Name',
			accessorKey: 'investorFirstName',
		},
		{
			header: 'Last Name',
			accessorKey: 'investorLastName',
		},
		{
			header: 'Email',
			accessorKey: 'investorEmail',
			enableClickToCopy: true,
		},
		{
			header: 'Date',
			accessorKey: 'date',
			Cell: ({ cell }) => {
				return DateHelper.formatDate(cell?.getValue());
			},
			size: 100,
		},
		{
			header: 'Available Cash',
			accessorKey: 'availableCash',
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
			size: 120,
		},
		{
			header: 'Order Amount',
			accessorKey: 'orderAmount',
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
			size: 120,
		},
		{
			header: 'Total Amount',
			accessorKey: 'totalAmount',
			Cell: ({ cell }) => {
				return currencyFormatterHelper(cell?.getValue());
			},
			size: 120,
		},
	];
}

